function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f1214;stroke:#0f1214;stroke-width:0.1px;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.064 0.062)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M582.557,127.339a.891.891,0,0,0-1.125-.619l-4.814,1.841a.933.933,0,0,0-.612.618l-3.47,11.333H560.976c-.408-1.23-2.452-8.578-2.452-8.578a.9.9,0,0,0-1.124-.619.945.945,0,0,0-.716,1.124l2.663,9.19a.966.966,0,0,0,.921.716h11.658c-.211.823-.513,1.948-.724,2.558H560.162a.914.914,0,0,0-.921.913.832.832,0,0,0,.921.823h11.763a.979.979,0,0,0,.912-.611l1.23-4.4h0c.2-.505,3.374-10.722,3.577-11.43.717-.3,4.4-1.736,4.4-1.736a.783.783,0,0,0,.619-.814.366.366,0,0,0-.105-.31Zm-21.891,20.008a2.051,2.051,0,0,0-2.036,2.053,2.045,2.045,0,0,0,4.089,0,2.066,2.066,0,0,0-2.053-2.053Zm11.048,0a2.059,2.059,0,0,0-2.046,2.053,2.045,2.045,0,0,0,4.09,0,2.059,2.059,0,0,0-2.045-2.053Z",
  transform: "translate(-556.663 -126.696)"
}));

var SvgShopCard = function SvgShopCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.114,
    height: 24.852,
    viewBox: "0 0 26.114 24.852",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shop-card.ec8d47f3.svg";
export { ForwardRef as ReactComponent };